import { render, staticRenderFns } from "./progress-column.vue?vue&type=template&id=18b01619&scoped=true"
import script from "./progress-column.vue?vue&type=script&lang=js"
export * from "./progress-column.vue?vue&type=script&lang=js"
import style0 from "./progress-column.vue?vue&type=style&index=0&id=18b01619&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b01619",
  null
  
)

export default component.exports